import React from "react";
import { useState, useEffect } from "react";
import styles from "./Order.module.css";
import { useSelector } from "react-redux";
import ProgressBar from "react-bootstrap/ProgressBar";

function Order({ order }) {
  const [deliveryStatus, setDeliveryStatus] = useState(0);
  const user = useSelector((state) => state.user);

  const deliveryMap = {
    "Preparando envío": 36,
    "En camino": 67,
    Entregado: 100,
  };
  useEffect(() => {
    setDeliveryStatus(deliveryMap[order.delivered]);
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between">
        <h3 className="fw-bold">Order #{order.id}</h3>
        <p className="text-muted mb-1 pt-2">
          Orden confirmada el día{" "}
          {new Date(order.createdAt).toLocaleDateString("es-ES")}
        </p>
      </div>
      <div className="row bg-light p-3 border border-1 mb-5">
        <div className="col-xl-6 col-md-12 mb-4">
          {order.items.map((item, index) => {
            return (
              <div key={index} className="d-flex mb-3">
                <div className={styles.divImg}>
                  <img src={item.image} alt="foto" className={styles.img} />
                </div>
                <div className="d-flex flex-column justify-content-between">
                  <h6 className={styles.productName + " fw-bold fs-5"}>
                    {item.name}
                  </h6>
                  <div
                    className={
                      styles.divToHide + " d-flex justify-content-start"
                    }
                  >
                    <div className="me-4">
                      <p className=" text-muted mb-0">Precio unitario:</p>
                      <h6 className={styles.orderText + " fs-5"}>
                        $ {item.price}
                      </h6>
                    </div>
                    <div>
                      <p className=" text-muted mb-0">Cantidad:</p>
                      <h6 className={styles.orderText + " fs-5"}>
                        {item.qty} unid.
                      </h6>
                    </div>
                  </div>
                  <p className={styles.productDescription + " mb-0"}>
                    {item.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        <div className="col-xl-6 col-md-12 d-flex row">
          <div className="col-lg-6 col-md-12 d-flex flex-column mb-4">
            <h6 className={styles.orderText + " fs-5 fw-bold"}>
              Dirección de entrega
            </h6>
            <p className={styles.purchaseSummary + " mt-4"}>{order.address}</p>
          </div>
          <div className="col-lg-6 col-md-12 d-flex flex-column">
            <h6 className={styles.orderText + " fs-5 fw-bold"}>
              Resumen de compra
            </h6>
            <span className="d-flex justify-content-between mt-4">
              <small className={styles.purchaseSummary}>Subtotal</small>
              <small className={styles.purchaseSummary}>
                $ {order.subtotal}
              </small>
            </span>
            <hr className={styles.lines} />

            <span className="d-flex justify-content-between">
              <small className={styles.purchaseSummary}>Envío</small>
              <small className={styles.purchaseSummary}>
                $ {order.shipping}
              </small>
            </span>
            <hr className={styles.lines} />

            <span className="d-flex justify-content-between">
              <small className={styles.purchaseSummary + " fw-semibold"}>
                Total
              </small>
              <small className={styles.purchaseSummary + " fw-semibold"}>
                $ {order.subtotal + order.shipping}
              </small>
            </span>
          </div>
        </div>
        <hr className={styles.lines + " mt-3"} />
        <div className="col-12">
          <p className="text-muted fw-semibold">Estado del envío</p>
          <ProgressBar
            className={styles.progressBarToHide}
            label={order.delivered}
            now={deliveryStatus}
          />
          <ProgressBar className={styles.progressBar} now={deliveryStatus} />
          <div className={styles.progressText}>
            <div className="text-center text-muted">Pedido creado</div>
            <div className="text-center text-muted">Preparando</div>
            <div className="text-center text-muted">En camino</div>
            <div className="text-center text-muted">Entregado</div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Order;
